import Vue from "vue";
import Router from "vue-router";
/* Layout */
import Layout from "./views/layout/Layout";
Vue.use(Router);

export const constantRouterMap = [
  {
    path: "/",
    component: Layout,
    redirect: "/login",
    // component: () => import('@/views/login'),
    children: [
      {
        path: "login",
        component: () => import("@/views/login"),
      },
      // {
      //   path: 'loginMobile',
      //   component: () => import('@/views/loginMobile')
      // }
    ],
    hidden: true,
  },
  { path: "/tPlus", component: () => import("@/views/tPlus"), hidden: true },
  {
    path: "/dingpreIndex",
    component: () => import("@/views/dingpreIndex"),
    hidden: true,
  },
  { path: "/404", component: () => import("@/views/404"), hidden: true },
  {
    path: "/dashboard",
    component: () => import("@/views/dashboard"),
    name: "Dashboard",
    hidden: true,
  },
  //邀请页
  {
    path: "/mobileInvitationPage",
    component: () => import("@/views/mobileInvitationPage"),
    hidden: true
  },
  //应聘路由
  {
    path: "/interviewRegister",
    component: () => import("@/views/mobileInterviewRegister"),
    hidden: true
  },
  //入职路由
  {
    path: "/staffRecord",
    component: () => import("@/views/staffRecord"),
    hidden: true
  },
  //法大大合同签署成功后提示页面
  {
    path: "/contractSignSucc",
    component: () => import("@/views/contractSignSucc"),
    hidden: true
  },
  //身份证上传路由
  {
    path:'/identityPage',
    name:'identityPage',
    component:()=>import('@/views/staffRecord/components/identityFilePage')
  },
  //个人简历上传路由
  {
    path:'/resumePage',
    name:'resumePage',
    component:()=>import('@/views/staffRecord/components/resumePage')
  },
  //毕业证书上传路由
  {
    path:'/diplomaPage',
    name:'diplomaPage',
    component:()=>import('@/views/staffRecord/components/diplomaPage')
  },
  //学位证书上传路由
  {
    path:'/degreePage',
    name:'degreePage',
    component:()=>import('@/views/staffRecord/components/degreePage')
  },
  //其他证书上传路由
  {
    path:'/otherCertificatesPage',
    name:'otherCertificatesPage',
    component:()=>import('@/views/staffRecord/components/otherCertificatesPage')
  },
  //一寸照片上传路由
  {
    path:'/issunPage',
    name:'issunPage',
    component:()=>import('@/views/staffRecord/components/issunPage')
  },
  {
    path: "/activityWriteInfo",
    component: () => import("@/views/mobileBookActivity"),
    hidden: true
  },
  {
    path: "/mobileQuestions",
    component: () => import("@/views/mobileQuestions"),
    hidden: true
  },
  {
    path: "/mobileHappyYear",
    component: () => import("@/views/mobileHappyYear"),
    hidden: true
  },
  {
    path: "/mobileBirthday",
    component: () => import("@/views/mobileBirthday"),
    hidden: true
  },
  {
    path: "/fileUpload",
    component: () => import("@/views/fileUpload"),
    hidden: true
  },
  {
    path: "/autoLogin",
    component: () => import("@/views/autoLogin"),
    hidden: true
  },
  {
    path: '/503',
    component: () => import('@/views/error-page-503'),
    hidden: true
  },
  {
    path: '/moneyCode',
    component: () => import('@/views/moneyCode'),
  },
  {
    path: '/payException',
    component: () => import('@/views/payException'),
  },
  {
    path: '/moneyDetailCode',
    component: () => import('@/views/moneyDetailCode'),
  },
  {   
    path: '/workorder',
    component: () => import('@/views/workorder'),
  },
  {   
    path: '/myWorkOrder',
    component: () => import('@/views/myWorkOrder'),
  },
  {   
    path: '/linkWorkOrder',
    component: () => import('@/views/linkWorkOrder'),
    hidden:true
  },
  {   
    path: '/codeLogin',
    component: () => import('@/views/codeLogin'),
    hidden:true
  },
  {   
    path: '/workMobile',
    component: () => import('@/views/workMobile'),
    hidden:true
  },
  {
    path: '/bigViewHome',
    component: () => import('@/views/bigViewHome'),
    hidden:true
  },
  {
    path: '/newWordOrderSubmit',
    component: () => import('@/views/newWordOrderSubmit'),
    hidden:true
  },
  {
    path: '/newWorkOrderHistory',
    name: 'newWorkOrderHistory',
    component: () => import('@/views/newWorkOrderHistory'),
    hidden:true
  },
  {
    path: '/newWorkOrderContent',
    component: () => import('@/views/newWorkOrderContent'),
    hidden:true
  },
  { // 待接收
    path: '/handOver',
    component: () => import('@/views/handOver'),
    hidden:true
  },
  { // 报销记录详情
    path: '/reimbursementApprovalDetail',
    component: () => import('@/views/reimbursementApprovalDetail'),
    hidden:true
  },
  { path: "*", redirect: "/404", hidden: true },
];

const outRouterList = [
  {
    path: "/",
    component: () => import('@/views/smsDemo'),
    hidden: true,
  },
  {
    path: '/detail/:id',
    name: 'Sms',
    component: () => import('@/views/sms'),
    hidden:true
  },
  { path: "*", redirect: "/404", hidden: true },
]
let routerObj = {}
console.log(process.env)
if (process.env.VUE_APP_IS_OUT === '1') {
  routerObj = {
    mode: "history",
    base: '/sms/',
    scrollBehavior: () => ({ y: 0 }),
    routes: outRouterList
  }
} else {
  routerObj = {
    mode: "history",
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap
  }
}
  
export default new Router(routerObj);
